module.exports = __webpack_public_path__ + "static/meretighan-dc1536e6d4dc982fda3eca08e17fb3de.jpg";